import React, { useEffect, useState } from 'react';
import { getArticles, deleteArticle, setFeaturedArticle } from '../../services/firestoreService';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import PageHead from '../../components/common/PageHead';
import ArticlesTable from './ArticlesTable';

const ITEMS_PER_PAGE = 10;

const ViewArticles = () => {
  const [articles, setArticles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [category, setCategory] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchArticles = async () => {
      const fetchedArticles = await getArticles();
      setArticles(fetchedArticles);
    };
    fetchArticles();
  }, []);

  const handleSetFeatured = async (articleId) => {
    await setFeaturedArticle(articleId);
    setArticles((prev) =>
      prev.map((a) => (a.id === articleId ? { ...a, isFeatured: !a.isFeatured } : a))
    );
  };

  const handleDelete = async (articleId) => {
    if (window.confirm('Are you sure you want to delete?')) {
      await deleteArticle(articleId);
      setArticles((prev) => prev.filter((a) => a.id !== articleId));
    }
  };

  const handleEdit = (articleId) => {
    navigate(`/edit-article/${articleId}`);
  };

  const filterByDate = (article) => {
    if (!startDate && !endDate) return true;
    const articleDate = article.dateCreated.toDate();
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    return (!start || articleDate >= start) && (!end || articleDate <= end);
  };

  const filteredArticles = articles.filter(
    (a) =>
      a.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (category ? a.category.toLowerCase() === category.toLowerCase() : true) &&
      filterByDate(a)
  );

  const totalPages = Math.ceil(filteredArticles.length / ITEMS_PER_PAGE);
  const indexOfLast = currentPage * ITEMS_PER_PAGE;
  const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
  const currentArticles = filteredArticles.slice(indexOfFirst, indexOfLast);

  return (
    <>
      <PageHead name="View Articles" />
      <div className="max-w-full mx-auto p-6">
        <div className="flex flex-col md:flex-row justify-between my-2 items-start md:items-center space-y-1 md:space-y-0 md:space-x-3">
          <input
            type="text"
            placeholder="Search by title"
            className="w-full px-4 py-2 border border-primary rounded-md shadow-lg focus:outline-none"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <FontAwesomeIcon icon={faSearch} className="text-xl text-primary hidden sm:block" />

          <select
            className="w-full md:w-48 px-4 py-2 border border-primary rounded-md shadow-lg"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            <option value="Guide">Guide</option>
            <option value="Health">Health</option>
            <option value="Business">Business</option>
          </select>

          <input
            type="date"
            className="w-full md:w-48 px-4 py-2 border border-primary rounded-md shadow-lg"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="w-full md:w-48 px-4 py-2 border border-primary rounded-md shadow-lg"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <ArticlesTable
          articles={currentArticles}
          onSetFeatured={handleSetFeatured}
          onEdit={handleEdit}
          onDelete={handleDelete}
          showIndex={true}
          startIndex={indexOfFirst}
        />

        <div className="flex justify-center mt-4">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={`mx-1 py-1 px-3 font-bold rounded ${
                currentPage === index + 1 ? 'underline text-secondary' : 'text-primary'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default ViewArticles;
